import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TNursing_NeedDefaultValues } from '../type';

import CommonPatientInfo from '../components/CommonPatientInfo';
import Contents1 from './Contents1';

import { updateNursingNeed } from 'apis/survey';
import Info from './Info';
import Contents2 from './Contents2';
import Contents3 from './Contents3';
import Contents4 from './Contents4';
import Contents5 from './Contents5';

const NursingNeed = (props: SurveyDialogProps<TNursing_NeedDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TNursing_NeedDefaultValues) => {
    const {} = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      nursing_needs_survey: {
        ...data,
      },
    };

    updateNursingNeed(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        간호·간병통합서비스 병동 간호필요도 일일평가표
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Info {...formProps} />
      <Contents1 patientInfo={patientInfo} {...formProps} />
      <Contents2 {...formProps} />
      <Contents3 {...formProps} />
      <Contents4 {...formProps} />
      <Contents5 {...formProps} />
    </MuiDialog.SurveyForm>
  );
};

export default NursingNeed;
